var _circle, _path, _path2, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthDydx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.75,
    fill: "url(#paint0_linear_133_1503)",
    stroke: "#505A69",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9474 11.28L12.1917 36.718H17.6431L35.4911 11.28H29.9474Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.211 11.28L23.4353 18.7757L20.7096 22.8643L12.646 11.28H18.211Z",
    fill: "url(#paint1_linear_133_1503)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4767 36.7201L24.6846 28.4293L27.4103 24.4543L35.9281 36.7201H30.4767Z",
    fill: "url(#paint2_linear_133_1503)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 11.75,
    fill: "white",
    stroke: "#505A69",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0023 26.76L35.8787 27.1817V39.4232L36.0023 39.5469L41.6841 36.1923L36.0023 26.76Z",
    fill: "#343434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9975 26.76L30.3157 36.1884L35.9975 39.5431V26.76Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9975 40.6222L35.9275 40.7075V45.0676L35.9975 45.2717L41.6831 37.2647L35.9975 40.6222Z",
    fill: "#3C3C3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9975 45.2728V40.6223L30.3157 37.2657L35.9975 45.2728Z",
    fill: "#8C8C8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9976 39.5468L41.6793 36.1922L35.9976 33.6091V39.5468Z",
    fill: "#141414"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3157 36.1884L35.9975 39.543V33.6005L30.3157 36.1884Z",
    fill: "#393939"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_1503",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_133_1503",
    x1: 16.9617,
    y1: 12.87,
    x2: 24.4404,
    y2: 21.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_133_1503",
    x1: 31.726,
    y1: 34.7893,
    x2: 22.5374,
    y2: 22.4021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6966FF",
    stopOpacity: 0.36
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthDydx);
export default __webpack_public_path__ + "static/media/EthDYDX.db468f3b8a8ba7dd02a52e18865504ba.svg";
export { ForwardRef as ReactComponent };